export default {
  defaultObject () {
    return {
      id: undefined,
      name: '',
      lastName: '',
      username: '',
      email: '',
      password: '',
      phone: '',
    }
  }
}